<template>
    <div class="w-full ap-option">
        <div class="flex items-baseline">
            <span class="font-bold">{{ item.accountNo }}</span>
            <span v-if="item.subKey" class="font-bold">:{{ item.subKey }}</span>
            <span v-if="showDisplayName" class="ml-2 truncate overflow-hidden text-ellipsis w-full ap-option-displayname">{{ item.displayName }}</span>
            <span v-if="isSelected && saccLinesCount">({{ saccLinesCount }})</span>
            <span class="grow"/>
            <edit-account-button :item="item"/>
            <span class="more-info-indicator kbd invisible mx-1">
                <i class="i-ph-arrow-right" />
            </span>
        </div>
        <div v-if="showBankInfo && bankAccount" class="flex justify-between items-end">
            <div>
                <i class="i-ph-bank inline-block text-base-content/40 text-xl -mb-1 mr-1"/> {{ bankAccount?.name }}
            </div>
            <div class="font-mono text-sm px-1">
                {{ formatBankAccountNo(bankAccount?.bban) }}
            </div>
            <tooltip placement="left">
                <template #tooltipAnchor>
                    <i class="i-ph-plugs-connected block text-primary text-lg"/>
                </template>
                <template #tooltipContent>
                    <div>Koblet til bankkonto</div>
                </template>
            </tooltip>
        </div>
        <div v-if="showBankInfo && !bankAccount" class="flex justify-between items-end">
            <tooltip placement="left">
                <template #tooltipAnchor>
                    <i class="i-ph-plugs block text-error text-lg m-1" @mousedown.stop="() => showNewAccountConnectionPopup = true"/>
                </template>
                <template #tooltipContent>
                    <div>Trykk for å koble til bankkonto</div>
                </template>
            </tooltip>
            <teleport v-if="showNewAccountConnectionPopup" to=".account-picker-container">
                <new-account-connection-popup
                    v-if="showNewAccountConnectionPopup"
                    :bookkeeping-account="props.item"
                    @close="() => showNewAccountConnectionPopup = false"
                />
            </teleport>
        </div>
    </div>
</template>

<script setup lang="ts">
import {findBankAccountByAccountNo, formatBankAccountNo} from '@/bank/bank-account.service'
import EditAccountButton from '@/subaccount/EditAccountButton.vue'
import {computed, ref} from 'vue'
import Tooltip from '@/components/Tooltip.vue'
import NewAccountConnectionPopup from '@/bank/NewAccountConnectionPopup.vue'

const props = defineProps({
    item: {
        type: Object as () => { accountNo: string, displayName: string, subKey: string | null },
        required: true
    },
    isSelected: {
        type: Boolean,
        default: false
    },
    showDisplayName: {
        type: Boolean,
        default: true
    },
    showBankInfo: {
        type: Boolean,
        default: false
    },
    saccLinesCount: {
        type: Number,
        default: 0
    }
})

const showNewAccountConnectionPopup = ref<boolean>(false)
const bankAccount = computed(() => findBankAccountByAccountNo(props.item.accountNo))

</script>

<style scoped>

</style>

<style>
@reference "@/index.css";
@reference "tailwindcss";

.vue-recycle-scroller__item-view {
    @apply border-b border-b-base-200;
}

.ap-option-displayname {
    @apply invisible;


}

.focused {
    .ap-option-displayname {
        @apply visible;
    }
}

.focused.account-picker-double.focused {
    .highlighted {
        .more-info-indicator {
            @apply visible;
            i {
                @apply block;
            }
        }
    }
}


</style>